import * as NavConst from '../components/constants/NavigationConstants';
import * as SweetAlert from '../components/common/utilities/ConfirmationAlert';
import { getApiPath, DELETE,  DASHBOARD_ITEMS, DASHBOARD_ITEMS_BY_DASHBOARD_ID, GENERIC_REQUEST, GENERIC_PAGINATED_KEY_VALUE_LIST } from '../api/ApiConst';
import ApiCaller from '../api/ApiCaller';

export const DashboardItem = {
  basePath: "dashboard-items",
  tableDataUrl:DASHBOARD_ITEMS_BY_DASHBOARD_ID,
  formUrl: NavConst.DASHBOARD_ITEM_DETAIL,
  label: "Dashboard Item",
  attributes: [{ name: "id", value: "id", type: "text", position: 0, formAttribute: false, tableAttribute: false },
  { name: "Dashboard ID", value: "dashboardId", type: "text", position: 1, formAttribute: false, className: "form-control input-default" },
  { name: "Name", value: "name", type: "text", position: 2, formAttribute: true, className: "form-control input-default" },
  { name: "Row", value: "row", type: "number", position: 3, formAttribute: true, className: "form-control input-default" },
  { name: "Column", value: "column", type: "number", position: 4, formAttribute: true, className: "form-control input-default" },
  { name: "Expand Horizontal", value: "expandH", type: "number", position: 5, formAttribute: true, className: "form-control input-default" },
  { name: "Expand Vertical", value: "expandV", type: "number", position: 6, formAttribute: true, className: "form-control input-default" },
  {
      name: "Request", value: "requestId", type: "select", position: 2, formAttribute: true, isStatic: false, basePath: "role",
      dataListFunction: () => {
        const options = []
        var jsonRequest = { "page": 0, "size": 200, searchFilters: [], sortRules: [] };
        ApiCaller.callPostApi(getApiPath(GENERIC_REQUEST, GENERIC_PAGINATED_KEY_VALUE_LIST), jsonRequest, {}, (response) => {
          response.data.map((d) => {
            options.push({ value: d.value, label: d.key })
          });
        }, (error) => {
          console.error(error);
        });
        return options
      }
  },
  {
    name: "View Type", value: "viewType", type: "select", position: 3, formAttribute: true, isStatic: true, dataList: [
      { value: "SINGLE_DATA_VIEW", label: "SINGLE_DATA_VIEW" },
      { value: "TABLE_VIEW", label: "TABLE_VIEW" },
      { value: "GRAPH_VIEW", label: "GRAPH_VIEW" },
      { value: "CUSTOM_VIEW", label: "CUSTOM_VIEW" }

    ],
    className: "form-control input-default"
  },
  { name: "Fetch Interval", value: "fetchInterval", type: "number", position: 5, formAttribute: true, className: "form-control input-default" },
  { name: "Real time", value: "realtime", type: "checkbox", i: 6, formAttribute: true, className: "form-control input-default" }
  ],
  actions: [
    { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
    {
      name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
      navigatePath: getApiPath(DASHBOARD_ITEMS, DELETE), replaceData: "{recordId}"
    },
    { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
    { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
  ]
};



